import React from 'react'

const RecentActivity = ({ item }) => {
    return (
        <>
            <div className='flex  md:flex-row justify-between items-center text-white'>
                <div className='flex items-center md:gap-5 gap-2 py-3'>
                    <img className='w-[25px]' src={item.busdIcon} alt="busdIcon" />
                    <p className='text-sm md:text-base'>{item.userIcon}</p>
                    <p className='text-sm md:text-base'>{item.user}</p>
                    <button className='py-2 md:px-6 px-3 rounded-[20px] text-blue-500 bg-[#444] hover:bg-[#555] text-xs md:text-base'>{item.userId}</button>
                    <p className='md:font-bold text-xs md:text-base'>{item.usedPrice} <span className='text-purple-500'>{item.subText}</span></p>
                </div>
                <div className='flex justify-center items-center text-sm md:text-base text-gray-400 gap-4'>
                    <p>{item.arroIcons}</p>
                    <p>{item.userTime}</p>
                </div>
            </div>
            <hr className='border-1 py-2 border-gray-600 w-full' />

        </>
    )
}

export default RecentActivity